(function(window, document, $) {
  'use strict';

  function getCartData(node) {
    try {
      return JSON.parse(node.getAttribute('data-cart-json') || '{}');
    } catch (error) {
      return {};
    }
  }

  function initCart() {
    var node = document.querySelector('[data-cartjs-config]');

    if (!node || !window.CartJS) {
      return;
    }

    window.CartJS.init(getCartData(node), {
      dataAPI: true,
      moneyFormat: node.getAttribute('data-money-format') || '',
      moneyWithCurrencyFormat: node.getAttribute('data-money-with-currency-format') || '',
      requestBodyClass: 'cart-loading'
    });
  }

  if ($) {
    $(initCart);
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCart);
  } else {
    initCart();
  }
}(window, document, window.jQuery));
